import { useState } from "react";
import OperacionesCambioCuotasAtrasadas from "./OperacionesCambioCuotasAtrasadas";

function SolicitudCambioCuotasAtrasadas({
  datosSolicitud,
  actualizarDatosTipoSolicitud,
}) {
  const [datosSolicitudLocal, setDatosSolicitudLocal] = useState({
    operaciones: datosSolicitud.operaciones,
  });

  function actualizarOperaciones(operaciones) {
    const nuevosDatos = {
      ...datosSolicitudLocal,
      operaciones: operaciones,
    };
    actualizarDatos(nuevosDatos);
  }

  function actualizarDatos(nuevosDatos) {
    setDatosSolicitudLocal(nuevosDatos);
    actualizarDatosTipoSolicitud(nuevosDatos);
  }

  return (
    <>
      <OperacionesCambioCuotasAtrasadas
        operaciones={datosSolicitudLocal.operaciones}
        actualizarOperaciones={actualizarOperaciones}
        permiteEditar="true"
        permiteEliminar="true"
      />
    </>
  );
}

export default SolicitudCambioCuotasAtrasadas;
